import { Component, OnInit } from '@angular/core';
import {DatiService} from '../../shared/dati.service';
import {ActivatedRoute} from '@angular/router';
import {Regioni} from '../../model/regioni';
import {Province} from '../../model/province';
import {Location} from '@angular/common';

@Component({
  selector: 'app-reg-detail',
  template: `
  <div *ngIf="!reg || !prov">
    <app-spinner></app-spinner>
  </div>
    <div class="container-fluid" *ngIf="reg">
      <span *ngFor="let regione of reg; index as i; last as last">
        <span *ngIf="last">
          <h2 class="text-center">
            <span style="color:green">Situazione</span>
            <span style="color: white"> in </span>  
            <span style="color: red">{{regione.denominazione_regione | uppercase}}</span>
          </h2>
        </span>
      </span>
      <div class="row">
        <div class="col-lg-3 cont">
          <div class="col-lg-12 bg">
            <span *ngFor="let regione of reg; index as i; last as last">
              <span *ngIf="last">
                <p>Attuali positivi</p>
              <div class="totalePositivi">
                {{regione.totale_positivi | number: '' : 'it-IT'}}
              </div>

            <div class="sub">
              <p class="subtitolo"> Incremento</p>
              <span class="totalePositivi">
            <div *ngIf="last">
              {{regione.totale_positivi - reg[i - 1].totale_positivi | number: '' : 'it-IT'}}
              <span style="font-size: 0.5em;color:lightgray">
                 ({{regione.totale_positivi - reg[i - 1].totale_positivi - (reg[i - 1].totale_positivi - reg[i - 2].totale_positivi) }})
              </span>
            </div>
          </span>
            </div>
              </span>
            </span>
          </div>
        </div>
        <div class="col-lg-3 cont">
          <div class="col-lg-12 bg">
            <span *ngFor="let regione of reg; index as i; last as last">
              <span *ngIf="last">
                <p>Dimessi guariti</p>
              <div class="guariti">
                {{regione.dimessi_guariti | number: '' : 'it-IT'}}
              </div>

            <div class="sub">
              <p class="subtitolo"> Incremento</p>
              <span class="guariti">
            <div *ngIf="last">
              {{regione.dimessi_guariti - reg[i - 1].dimessi_guariti | number: '' : 'it-IT'}}
              <span style="font-size: 0.5em;color:lightgray">
                 ({{regione.dimessi_guariti - reg[i - 1].dimessi_guariti - (reg[i - 1].dimessi_guariti - reg[i - 2].dimessi_guariti) }})
              </span>
            </div>
          </span>
            </div>
              </span>
            </span>
          </div>
        </div>
        <div class="col-lg-3 cont">
          <div class="col-lg-12 bg">
            <span *ngFor="let regione of reg; index as i; last as last">
              <span *ngIf="last">
                <p>Deceduti</p>
              <div class="deceduti">
                {{regione.deceduti | number: '' : 'it-IT'}}
              </div>

            <div class="sub">
              <p class="subtitolo"> Incremento</p>
              <span class="deceduti">
            <div *ngIf="last">
              {{regione.deceduti - reg[i - 1].deceduti | number: '' : 'it-IT'}}
              <span style="font-size: 0.5em;color:lightgray">
                 ({{regione.deceduti - reg[i - 1].deceduti - (reg[i - 1].deceduti - reg[i - 2].deceduti) }})
              </span>
            </div>
          </span>
            </div>
              </span>
            </span>
          </div>
        </div>
        <div class="col-lg-3 cont">
          <div class="col-lg-12 bg">
            <span *ngFor="let regione of reg; index as i; last as last">
              <span *ngIf="last">
                <p>Casi totali</p>
              <div class="totaleCasi">
                {{regione.totale_casi | number: '' : 'it-IT'}}
              </div>

            <div class="sub">
              <p class="subtitolo"> Incremento</p>
              <span class="totaleCasi">
            <div *ngIf="last">
              {{regione.totale_casi - reg[i - 1].totale_casi | number: '' : 'it-IT'}}
              <span style="font-size: 0.5em;color:lightgray">
                 ({{regione.totale_casi - reg[i - 1].totale_casi - (reg[i - 1].totale_casi - reg[i - 2].totale_casi) }})
              </span>
            </div>
          </span>
            </div>
              </span>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="col-md-12 fisso">
            <table class="table table-dark">
              <thead>
              <tr>
                <td>Provincia</td>
                <th>Casi totali</th>
                <th>Incremento</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let provincia of prov; index as i ">
                <td>{{provincia.denominazione_provincia}}</td>
                <td style="color:rgb(255,170, 0)">{{provincia.totale_casi | number: '' : 'it-IT'}}</td>
                <td style="color:red">{{provincia.totale_casi - prov2[i].totale_casi}}</td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>
        <div class="col-md-6 cont" style="margin-top:-15px">
          <div class="col-md-12 bg">
            <p>Tamponi effettuati: <span *ngFor="let regione of reg; index as i; last as last">
          <div class="tamponi" *ngIf="last">
            {{regione.tamponi - reg[i - 1].tamponi | number: '' : 'it-IT'}}
          </div>
        </span></p>
            <div class="sub">
              <p class="subtitolo"> Incidenza dei positivi rispetto ai tamponi</p>
              <span class="tamponi" *ngFor="let regione of reg; index as i; last as last;">
            <div *ngIf="last">
              <span style="font-size: 1em;color:lightgray">
                {{(regione.nuovi_positivi/(regione.tamponi - reg[i - 1].tamponi)) *100 | number: '1.1-1'}} %
              </span>
            </div>
          </span>
            </div>
            <button class="btn btn-warning float-right"> <i class="fa fa-fast-backward" aria-hidden="true" (click)="goBack()"></i> Torna Indietro</button>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>  
  `,
  styleUrls: ['./reg-detail.component.css']
})
export class RegDetailComponent implements OnInit {
  id: string;
  reg: Regioni[];
  prov: Province[];
  prov2 : Province[];
  date: any; // data attuale
  date2: any; // data di ieri

  constructor(
    private datiService: DatiService,
    private route: ActivatedRoute,
    private location: Location  
  ) { }

  ngOnInit(): void {
    this.getDetailReg();
    this.getProvDetail();
    
  }

  getDetailReg() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.datiService.detailReg(this.id)
      .subscribe(res => {
        this.reg = res.filter(t => t.denominazione_regione === this.id);
        console.log(this.reg);
      })
  }

  getProvDetail() {
    this.date = new Date().toISOString().slice(0, 10);
    this.date2 = new Date(Date.now() - 1 *24 *60 *60 *1000).toISOString().slice(0, 10);
    this.id = this.route.snapshot.paramMap.get('id');
    this.datiService.detailProv()
        .subscribe(res => {
          this.prov = res.filter(t=> t.denominazione_regione === this.id).filter((value ,index, self) =>self.indexOf(value) === index);
          this.prov = [...new Map(this.prov.map(item =>
          [item[`denominazione_provincia`], item])).values()];
        this.prov2 = res.filter(t=> t.data.slice(0, 10) === this.date2).filter(t=> t.denominazione_regione === this.id).filter((value ,index, self) =>self.indexOf(value) === index);

        })
  }

  goBack(): void {
    this.location.back();
  }

}
  
